import { ref } from "vue";
import { promotionApi, type CampaignView } from "@/api/promotion.api";

const campaigns = ref<CampaignView[]>([]);
const loading = ref(false);
const error = ref<string | null>(null);

async function refreshAll(): Promise<void> {
  loading.value = true;
  error.value = null;
  try {
    campaigns.value = await promotionApi.campaigns();
  } catch (err: any) {
    error.value = err.message ?? "campaigns failed";
    campaigns.value = [];
  } finally {
    loading.value = false;
  }
}

export function usePromotion() {
  return {
    campaigns,
    loading,
    error,
    refreshAll,
  };
}
